/**
 * 判断值是否为函数
 * @return 是否为函数
 */
function isFunction(value) {
    return typeof value === 'function';
}

export { isFunction as default };
//# sourceMappingURL=is-function.js.map
